import enviro from 'enviro';
import { APP_IDS, DEFAULT_APP_ID, ECOMMERCE_OBJECT_LABEL_PROPERTIES } from 'ContentData/constants/ecommerce';
export const getAppId = (source = DEFAULT_APP_ID) => {
  const sourceAppIds = APP_IDS[source] || APP_IDS[DEFAULT_APP_ID];
  return enviro.isQa() ? sourceAppIds.QA : sourceAppIds.PROD;
};
export const getEcommerceObjectFromCrmObject = (crmObject, objectType) => {
  var _properties$labelProp;
  const {
    objectId,
    properties
  } = crmObject;
  const labelPropertyName = ECOMMERCE_OBJECT_LABEL_PROPERTIES[objectType];
  const labelProperty = properties === null || properties === void 0 || (_properties$labelProp = properties[labelPropertyName]) === null || _properties$labelProp === void 0 ? void 0 : _properties$labelProp.value;
  if (objectId && labelProperty) {
    return {
      name: labelProperty,
      hubSpotObjectId: objectId
    };
  }
  return null;
};